import React from 'react';
import AdminCRUD from './AdminCRUD';

const AdminHeroImages = () => {
  const fields = [
    { name: 'url', label: 'Image URL', type: 'url', required: true, placeholder: 'https://images.unsplash.com/...', fullWidth: true },
    { name: 'alt', label: 'Alt Text', type: 'text', required: true, placeholder: 'Description of image' },
    { name: 'order', label: 'Order', type: 'number', default: 0, min: 0, max: 100 },
    { name: 'active', label: 'Status', type: 'boolean', checkboxLabel: 'Active', default: true },
  ];

  const columns = [
    { 
      key: 'url', 
      label: 'Image',
      render: (url) => <img src={url} alt="" className="table-thumb" />
    },
    { key: 'alt', label: 'Alt Text' },
    { key: 'order', label: 'Order' },
    { 
      key: 'active', 
      label: 'Status',
      render: (active) => <span className={`status-badge ${active ? 'active' : 'inactive'}`}>{active ? 'Active' : 'Inactive'}</span>
    },
  ];

  return (
    <AdminCRUD
      title="Hero Images"
      endpoint="hero-images"
      fields={fields}
      columns={columns}
      renderPreview={true}
    />
  );
};

export default AdminHeroImages;
